// ForgotPassword.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { apiFetchJson } from "../apiClient";
import "../auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      // The backend always returns the same generic message here, regardless
      // of whether the email exists — never surface anything more specific.
      const res = await apiFetchJson("/api/v1/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setMessage(res.message);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Forgot Password</h2>
        <p className="auth-subtitle">
          Enter your email and we'll send you a link to reset your password.
        </p>
        {error && <p className="auth-error">{error}</p>}
        {message ? (
          <p className="auth-subtitle">{message}</p>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="auth-btn" disabled={submitting}>
              {submitting ? "Sending…" : "Send Reset Link"}
            </button>
          </form>
        )}
        <p className="auth-link">
          <Link to="/signin">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
